import React from 'react';
import Container from './Container';

export default ({ onClick }) => <Container onClick={onClick}>Login as user</Container>;
